import FormData from "form-data";

import { deserialize } from "../base.serializer";

export const fileUpload = async (
  token,
  baseUrl,
  file,
  recaptchaToken = null,
  recaptchaVersion = null
) => {
  if (!file) {
    throw new Error("Missing required argument: file");
  }

  const queryPath = `${baseUrl}/api/v2/file_uploads`;
  try {
    const formData = new FormData();
    formData.append("data[attributes][file]", file);
    if (recaptchaToken) {
      formData.append("data[attributes][g_recaptcha_response]", recaptchaToken);
      if (recaptchaVersion) {
        formData.append(
          "data[attributes][recaptcha_version]",
          recaptchaVersion
        );
      }
    }
    let res = await fetch(queryPath, {
      method: "post",
      headers: {
        Accept: "application/json",
        ...(token && { "x-api-token": `Bearer ${token}` })
      },
      body: formData,
      credentials: "same-origin"
    });
    res = await res.json();
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
